import React from 'react'
import { Film } from 'lucide-react'
import { MoreOptionsButton } from '../../Buttons/MoreOptionsButton'
import {
  StoryboardHeader as StoryboardHeaderStyled,
  StoryboardHeaderRow,
  StoryboardIconTitleGroup,
  StoryboardIcon,
  StoryboardCategoryTitle,
  StoryboardSubheading,
  StoryboardContentTitle,
  HeaderActionsGroup,
} from '../styles/StoryboardNodeStyles'

interface StoryboardHeaderProps {
  nodeId: string
  zoomScale: number
  displayTitle: string
  onDeleteNode: (nodeId: string) => void
  onDownloadPNG?: () => Promise<void>
  onCopyToClipboard?: () => Promise<void>
}

export const StoryboardNodeHeader = React.memo(
  ({
    nodeId,
    zoomScale,
    displayTitle,
    onDeleteNode,
    onDownloadPNG,
    onCopyToClipboard,
  }: StoryboardHeaderProps) => (
    <>
      <StoryboardHeaderStyled>
        <StoryboardHeaderRow>
          <StoryboardIconTitleGroup $zoomScale={zoomScale}>
            <StoryboardIcon>
              <Film size={16} strokeWidth={2} />
            </StoryboardIcon>
            <StoryboardCategoryTitle>Storyboard</StoryboardCategoryTitle>
          </StoryboardIconTitleGroup>
          <HeaderActionsGroup $zoomScale={zoomScale} onClick={(e) => e.stopPropagation()}>
            <MoreOptionsButton
              nodeId={nodeId}
              onDelete={onDeleteNode}
              onDownloadPNG={onDownloadPNG}
              onCopyToClipboard={onCopyToClipboard}
              className="nodrag"
              size={14}
              hideCopy
            />
          </HeaderActionsGroup>
        </StoryboardHeaderRow>
        <StoryboardSubheading>Visual narrative for your idea</StoryboardSubheading>
      </StoryboardHeaderStyled>

      <StoryboardContentTitle title={displayTitle}>{displayTitle}</StoryboardContentTitle>
    </>
  )
)

StoryboardNodeHeader.displayName = 'StoryboardNodeHeader'
